export var conditions = function (runIf, rule) {
    return function (value, values, texts) {
        var isRequired = Object.keys(runIf).every(function (key) {
            if (typeof values === 'object' && values != null && values.hasOwnProperty(key)) {
                return values[key] === runIf[key];
            }
            return false;
        });
        if (!isRequired) {
            return '';
        }
        return rule(value, values, texts);
    };
};
//# sourceMappingURL=conditions.js.map